import ButtonSave from "../../UniversalEditModal/components/ButtonSave";
import ShowcaseSection from "./ShowcaseSection";
import UserMainSpecSelect from "./sections/UserMainSpecSelect";
import UserTeamSelect from "./sections/UserTeamSelect";
import MultiSelectCamouflage from "../../other/MultiSelectCamouflage/MultiSelectCamouflage";
import UserAchievementsSelect from "./sections/UserAchievementsSelect";

interface Props {
    teamList: string[];
    hasUnsavedChanges: boolean;
}

export default function UserShowcaseTab({ hasUnsavedChanges, teamList }: Props) {
    return (
        <>
            <ShowcaseSection>
                <UserMainSpecSelect />
                <UserTeamSelect teamList={teamList || []} />
                <MultiSelectCamouflage type="profile" />
                <UserAchievementsSelect />
            </ShowcaseSection>

            <ButtonSave hasUnsavedChanges={hasUnsavedChanges} />
        </>
    );
}